import { useState } from "react";
import WebLayout from "../../../layout/WebLayout";
import profileAction from "../../../stores/actions/profileAction";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

function ChangePassword() {
  const dispatch = useDispatch<any>();
  const [oldPassword, setOldPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<any>(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      dispatch(
        profileAction.changePassword({
          old_password: oldPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        })
      );
    } catch (error: any) {
      toast.error(error.message);
    }
  };
  return (
    <WebLayout pageName={"Profile"}>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="col-lg-6 offset-lg-3">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">Change Password</h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 col-md-12 form-password-toggle fv-plugins-icon-container">
                    <label className="form-label">Current Password</label>
                    <div className="input-group input-group-merge has-validation">
                      <input
                        className="form-control"
                        type={showOldPassword ? "text" : "password"}
                        name="oldPassword"
                        id="oldPassword"
                        placeholder="············"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        onClick={() => setShowOldPassword(!showOldPassword)}>
                        <i
                          className={`bx ${
                            showOldPassword ? "bx-show" : "bx-hide"
                          }`}></i>
                      </span>
                    </div>
                    <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                  </div>

                  <div className="mb-3 col-md-12 form-password-toggle fv-plugins-icon-container">
                    <label className="form-label">New Password</label>
                    <div className="input-group input-group-merge has-validation">
                      <input
                        className="form-control"
                        type={showNewPassword ? "text" : "password"}
                        id="newPassword"
                        name="newPassword"
                        placeholder="············"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        onClick={() => setShowNewPassword(!showNewPassword)}>
                        <i
                          className={`bx ${
                            showNewPassword ? "bx-show" : "bx-hide"
                          }`}></i>
                      </span>
                    </div>
                    <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                  </div>
                  <div className="mb-3 col-md-12 form-password-toggle fv-plugins-icon-container">
                    <label className="form-label">Confirm Password</label>
                    <div className="input-group input-group-merge has-validation">
                      <input
                        className="form-control"
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        id="confirmPassword"
                        placeholder="············"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }>
                        <i
                          className={`bx ${
                            showConfirmPassword ? "bx-show" : "bx-hide"
                          }`}></i>
                      </span>
                    </div>
                    <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                  </div>
                  <div className="col-12 mt-1">
                    <button type="submit" className="btn btn-primary me-2">
                      Save changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default ChangePassword;
